import { GET_DOCUMENTS } from "../services/get-documents";
import { DELETE_DOCUMENT } from "../services/delete-document";
import { DELETE_DOCUMENT_LIBRARY } from "../services/delete-document-library";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";
import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../mdae-framework";
import { EDIT_DOCUMENT } from "../services/edit-document";
import { GET_USER_PERMISSION } from "../services/get-user-permission";
import { GET_USER_DOCUMENT_CATEGORY_LIST } from "../services/get-document-category-list";
import { GET_DOCUMENT_MANAGEMENT_CLIENT_CONFIG } from "../services/get-document-management-client-config";
import { GET_DOCUMENT_MANAGEMENT_CONFIG } from "../services/get-document-management-configurations";
import applyChanges from "devextreme/data/apply_changes";
import Guid from "devextreme/core/guid";
import { first } from "lodash";
import { EDIT_OR_ATTACH_COMPONENT_MODES } from "../edit-or-attach-document";
import { GET_EHR_DOCUMENTS } from "../services/get-ehr-documents";
import mdaeNotify, { NOTIFY_MESSAGE_TYPE } from "../../common_widgets/toast/notify";
const CLEAR_SAVE_USER_DOCUMENT_DATA = "CLEAR_SAVE_USER_DOCUMENT_DATA";
export const REFRESH_USER_DOCUMENT_GRID = "REFRESH_USER_DOCUMENT_GRID";
const SET_LOADING_TRUE = "SET_LOADING_TRUE";
const SET_LOADING_FALSE = "SET_LOADING_FALSE";
export const TOGGLE_DOCUMENT_LIST_POPUP = "TOGGLE_DOCUMENT_LIST_POPUP";
export const TOGGLE_DOCUMENT_DATA_GRID_ACTION_POPOVER =
  "TOGGLE_DOCUMENT_DATA_GRID_ACTION_POPOVER";
export const TOGGLE_DL_DATA_GRID_ACTION_POPOVER =
  "TOGGLE_DL_DATA_GRID_ACTION_POPOVER";
export const TOGGLE_EDIT_DOCUMENT_POPUP = "TOGGLE_EDIT_DOCUMENT_POPUP";
export const SET_DOCUMENT_STORE_DATASOURCE = "SET_DOCUMENT_STORE_DATASOURCE";
export const SET_DATE_RANGE_DATA = "SET_DATE_RANGE_DATA";
export const SET_HEADER_RANGE_FILTER_COUNT = "SET_HEADER_RANGE_FILTER_COUNT";
export const SET_DOCUMENT_GRID_CHECKBOXES = "SET_DOCUMENT_GRID_CHECKBOXES";

export const SET_CURRENT_USER_ACTION_MODE = "SET_CURRENT_USER_ACTION_MODE";
export const SET_DOCUMENT_POPUP_MODE = "SET_DOCUMENT_POPUP_MODE";
export const REMOVE_SELECTED_FILE = "REMOVE_SELECTED_FILE";
export const SAVE_DOCUMENT_UPLOAD_GRID_DATA = "SAVE_DOCUMENT_UPLOAD_GRID_DATA";
export const TOGGLE_DOCUMENT_SELECT_ALL_FLAG =
  "TOGGLE_DOCUMENT_SELECT_ALL_FLAG";
export const SET_DOCUMENT_DATA_TO_SAVE = "SET_DOCUMENT_DATA_TO_SAVE";
export const TOGGLE_WAIT_TIME_MESSAGE_POPUP = "TOGGLE_WAIT_TIME_MESSAGE_POPUP";
export const SET_INCLUDE_NON_AUDIT_LEVEL_DOCUMENTS =
  "SET_INCLUDE_NON_AUDIT_LEVEL_DOCUMENTS";
export const SET_IS_STOP_DOCUMENT_POLLING = "SET_IS_STOP_DOCUMENT_POLLING";
export const TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP =
  "TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP";
export const TOGGLE_DL_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP =
  "TOGGLE_DL_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP";
export const SET_ZIP_FILE_DOWNLOAD_NAME = "SET_ZIP_FILE_DOWNLOAD_NAME";
export const SET_SINGLE_DOCUMENT_DATA = "SET_SINGLE_DOCUMENT_DATA";
export const SET_DOCUMENT_UPLOAD_PROGRESS = "SET_DOCUMENT_UPLOAD_PROGRESS";
export const SET_DOCUMENT_UPLOAD_CURRENT_SELECTED_TAB = "SET_DOCUMENT_UPLOAD_CURRENT_SELECTED_TAB";
export const SET_SELECTED_ROW_DATA = "SET_SELECTED_ROW_DATA";
export const SET_ATTACH_DOCUMENT_COMPONENT_MODE = "SET_ATTACH_DOCUMENT_COMPONENT_MODE";
export const SET_EPIC_NOTES_SELECTED_ROWS = "SET_EPIC_NOTES_SELECTED_ROWS";
export const UPDATE_EPIC_NOTES_SELECTED_ROWS = "UPDATE_EPIC_NOTES_SELECTED_ROWS";
export const RESET_EHR_DOCUMENTS = "RESET_EHR_DOCUMENTS";
export const SET_DOCUMENT_LIBRARY_SELECTED_ROWS = "SET_DOCUMENT_LIBRARY_SELECTED_ROWS";
export const RESET_DOCUMENT_LIBRARY_ROWS = "RESET_DOCUMENT_LIBRARY_ROWS";
export const clearSaveDocumentData = () => ({
  type: CLEAR_SAVE_USER_DOCUMENT_DATA,
});
export const refreshDocumentGrid = () => ({ type: REFRESH_USER_DOCUMENT_GRID });
export const setLoadingTrue = () => ({ type: SET_LOADING_TRUE });
export const setLoadingFalse = () => ({ type: SET_LOADING_FALSE });
export const documentUploadDatagridKeyExpr = "documentUploadDatagridKeyExpr";
export const addCommonProperties = (object: any) => {
  object[documentUploadDatagridKeyExpr] = new Guid().toString();
  object["createdOn"] = new Date();
  object["updatedOn"] = new Date();
}; 
const initialError = {
  code: "",
  message: "",
  value: [],
};
export var documentManagementGridInstance = null;
export const formatDocumentToSaveObjectForUpdate = (documentToSave) =>{
  return ({
    documentId: documentToSave.documentId,
    documentName: documentToSave.documentName,
    documentCategoryId: documentToSave.documentCategoryId
  });
}

export const documentsGridSelection = {
  mode: "single",
  showCheckBoxesMode: "always",
  selectAllMode: "allPages",
  allowSelectAll: false,
};
const initialDocumentCategories = {
  internalWorkflowDocumentCategories: [],
  externalWorkflowDocumentCategories: [],
  maintenanceWorkflowDocumentCategories: [],
};
export const initialDocumentDataToSave:{
  [key: string]: any;
  selectedFile: File;
  uploadProgress: number;
  documentUploadDatagridKeyExpr: string;
  s3ObjectName: string;
  fileSize: number;
} = {
  documentName: "",
  documentId: 0,
  originalFileName: "",
  fileSize: null,
  documentCategoryId: null,
  attachedLevelId: 0,
  activeInd: 1,
  uploadInd: 0,
  attachedLevelName: "",
  showForCoderReviewInd: 0,
  saveToDocumentManagement: false,
  selectedFile: null,
  documentUploadDatagridKeyExpr: null,
  uploadProgress: null,
  s3ObjectName: "",
};

const initialState: {
  [key: string]: any;
  documentDataToSave: Array<typeof initialDocumentDataToSave>;
} = {
  loading: false,
  refreshDocumentGrid: false,
  error: initialError,
  documentDataToSave: [],
  headerRangeFilterCount: 6,
  isDocumentGridCheckboxesVisible: false,
  documentsGridSelection,
  selectedDocuments: [],
  documentCategoryList: initialDocumentCategories,
  attachedDocumentList: [],
  isProgressLoadIndicatorVisible: false,
  progressLoadIndicatorValue: 0,
  totalDocumentSpaceAvailable: 0,
  notVisiblDocumentCount: 0,
  notVisibleUtilizedFileSize: 0,
  documentAttachmentLevels: {},
  hasBulkDocumentdeletePermission: false,
  totalDataAllowance: 0,
  totalDocumentCount: 0,
  totalUtilizedFileSize: 0,
  savedDocumentData: {},
  dataAllowance: 0,
  isDocumentManagementEnabled: false,
  isDocumentUploadDisabled: true,
  documentsAttachedToCaseCount: 0,
  isWaitTimeMessagePopupVisible: false,
  includeNonAuditLevelDocumentInd: false,
  isStopDocumentPooling: false,
  attachedLevelName: '',
  attachedLevelId: '',
  documentStore: {},
  documentDataToSaveStore: {},
  attachDocumentComponentCurrentMode: EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER,
  currentSelectedTab: 1,
  selectedKeysStore: {},
  selectedRowsData: [],
  selectedDocumentId:0,
  ehrConnectorData: {
    ehrDocuments: [],
    selectedEhrDocuments: []
  },
  documentLibraryConnectorData: {
    selectedDocumentLibraryRows: []
  },
  isDlActionPopoverVisible: false,
  dlActionPopoverTarget: null,
};
const DocumentManagementReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      //get user docs
      if (isAsyncOperation(GET_DOCUMENTS)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_DOCUMENTS)(action)) {
        let updatedDocumentList = [];
        const documentList = action.response.data.documentList;
        const uniqueId = (first(action.args )as any).uniqueId;
        if (action.response.data.documentList) {
          updatedDocumentList = [...action.response.data.documentList];
          updatedDocumentList.forEach((element, index) => {
            const originalFileName =
              updatedDocumentList[index].originalFileName;
            updatedDocumentList[index].fileType = originalFileName
              ? originalFileName
                  .split(".")
                  .pop()
                  .toLowerCase()
              : "";
          });
          updatedDocumentList.sort(
            (a, b) =>
              new Date(b.updateDate).getMilliseconds() -
              new Date(a.updateDate).getMilliseconds()
          );
        }
        const isDocumentLibrary = (first(action.args) as any).attachedLevelName === 'DL';
        return {
          ...state,
          attachedDocumentList: updatedDocumentList,
          refreshDocumentGrid: false,
          loading: false,
          documentStore: {
            ...state.documentStore,
            [uniqueId]: documentList
          },
          ...(!isDocumentLibrary && {
            totalUtilizedFileSize: action.response.data.totalUtilizedFileSize,
            totalDatAllowance: action.response.data.totalDataAllowance,
            totalDocumentCount: action.response.data.totalDocumentCount,
            totalDocumentSpaceAvailable: action.response.data.totalDocumentSpaceAvailable,
            notVisiblDocumentCount: action.response.data.notVisiblDocumentCount,
            notVisibleUtilizedFileSize: action.response.data.notVisibleUtilizedFileSize,
            documentAttachmentLevels: action.response.data.documentAttachmentLevels[0],
          })
        };
      }
      if (isAsyncComplete(GET_DOCUMENT_MANAGEMENT_CONFIG)(action)) {
        const response = action.response.data;
        return {
          ...state,
          totalUtilizedFileSize: response.totalUtilizedFileSize,
          totalDataAllowance: response.totalDataAllowance,
          documentAttachmentLevels: response.documentAttachmentLevels[0],
          totalDocumentSpaceAvailable: response.totalDocumentSpaceAvailable,
        };
      }
      if (isAsyncFailure(GET_DOCUMENTS)(action)) {
        return {
          ...state,
          loading: false,
          error: action.error,
          refreshDocumentGrid: false,
        };
      }
      //get permission
      if (isAsyncOperation(GET_USER_PERMISSION)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_USER_PERMISSION)(action)) {
        return {
          ...state,
          hasBulkDocumentdeletePermission:
            action.response.hasBulkDocumentdeletePermission,
          loading: false,
        };
      }
      if (isAsyncFailure(GET_USER_PERMISSION)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      //edit user docs
      if (isAsyncOperation(EDIT_DOCUMENT)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(EDIT_DOCUMENT)(action)) {
        return { ...state, refreshDocumentGrid: true, loading: false };
      }
      if (isAsyncFailure(EDIT_DOCUMENT)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //delete user docs
      if (isAsyncOperation(DELETE_DOCUMENT)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(DELETE_DOCUMENT)(action)) {
        return { ...state, refreshDocumentGrid: true, loading: false };
      }
      if (isAsyncFailure(DELETE_DOCUMENT)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      if (isAsyncOperation(DELETE_DOCUMENT_LIBRARY)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(DELETE_DOCUMENT_LIBRARY)(action)) {
        return { ...state, refreshDocumentGrid: true, loading: false };
      }
      if (isAsyncFailure(DELETE_DOCUMENT_LIBRARY)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      //doc categories
      if (isAsyncComplete(GET_USER_DOCUMENT_CATEGORY_LIST)(action)) {
        return { ...state, documentCategoryList: action.response.data };
      }

      if (isAsyncOperation(GET_DOCUMENT_MANAGEMENT_CLIENT_CONFIG)(action)) {
        return {
          ...state,
          isDocumentManagementEnabled: false,
          isDocumentUploadDisabled: true,
          isEhrInboundAPIEnabled: false
        };
      }
      if (isAsyncComplete(GET_DOCUMENT_MANAGEMENT_CLIENT_CONFIG)(action)) {
        return {
          ...state,
          isDocumentManagementEnabled:
            action.response?.isDocumentManagementEnabled,
          isDocumentUploadDisabled: action.response?.isDocumentUploadDisabled,
          isEhrInboundAPIEnabled: action.response?.isEhrInboundAPIEnabled
        };
      }
      if (isAsyncFailure(GET_EHR_DOCUMENTS)(action)) {
        mdaeNotify({
            message: "Failed to fetch EHR documents.",
            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
        return { ...state, error: action.error };
      }

      if (isAsyncComplete(GET_EHR_DOCUMENTS)(action)) {
        const ehrDocuments = action.response.ehrDocuments || [];
        const args = first(action.args) as any;
        ehrDocuments.forEach((x) => {
          x.mrn = args.mrn;
          x.dos = `${args.dateStart} - ${args.dateEnd}`;
        });
        return {
          ...state, ehrConnectorData: {
            ...state.ehrConnectorData,
            ehrDocuments
          }
        };
      }

      return state;
    case SET_DOCUMENT_STORE_DATASOURCE:
      return {
        ...state, ...action.data,
        documentStore: {
          ...state.documentStore,
          ...action.data.documentStore
        }
      };
    case RESET_EHR_DOCUMENTS:
      return {
        ...state,
        ehrConnectorData: {
          ...state.ehrConnectorData,
          ehrDocuments: []
        },
      };
    case RESET_DOCUMENT_LIBRARY_ROWS:
      return {
        ...state,
        documentLibraryConnectorData: {
          selectedDocumentLibraryRows: []
        }
      };
    case SET_DOCUMENT_LIBRARY_SELECTED_ROWS:
      return {
        ...state,
        documentLibraryConnectorData: {
          ...state.documentLibraryConnectorData,
          selectedDocumentLibraryRows: action.data.selectedDocumentLibraryRows
        }
      };
    case SET_DOCUMENT_DATA_TO_SAVE:
      return {
        ...state, documentDataToSaveStore: {
          ...state.documentDataToSaveStore,
          [action.data.uniqueId]: action.data.documentDataToSave
        }
      };
    case SET_EPIC_NOTES_SELECTED_ROWS:
      return {
        ...state, ehrConnectorData: {
          ...state.ehrConnectorData,
          selectedEhrDocuments: action.data.selectedEhrDocuments
        }
      };
    case UPDATE_EPIC_NOTES_SELECTED_ROWS: {
      const selectedKeys = new Set(state.ehrConnectorData.selectedEhrDocuments);
      (action.data.removed ?? []).forEach((key) => selectedKeys.delete(key));
      (action.data.added ?? []).forEach((key) => selectedKeys.add(key));
      return {
        ...state, ehrConnectorData: {
          ...state.ehrConnectorData,
          selectedEhrDocuments: Array.from(selectedKeys)
        }
      };
    }

    case SET_DATE_RANGE_DATA:
    case SET_HEADER_RANGE_FILTER_COUNT:
    case SET_DOCUMENT_GRID_CHECKBOXES:
    case TOGGLE_EDIT_DOCUMENT_POPUP:
    case TOGGLE_DOCUMENT_DATA_GRID_ACTION_POPOVER:
    case TOGGLE_DL_DATA_GRID_ACTION_POPOVER:
    case TOGGLE_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP:
    case TOGGLE_DL_ZIP_FILE_DOWNLOAD_CONFIRM_POPUP:
    case SET_ZIP_FILE_DOWNLOAD_NAME:
    case SET_DOCUMENT_UPLOAD_CURRENT_SELECTED_TAB:
    case SET_SELECTED_ROW_DATA:
    case SET_ATTACH_DOCUMENT_COMPONENT_MODE:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;

    case CLEAR_SAVE_USER_DOCUMENT_DATA:
      return { ...state, savedDocumentData: {} };
    case REFRESH_USER_DOCUMENT_GRID:
      return { ...state, refreshDocumentGrid: true };
    case SET_LOADING_TRUE:
      return { ...state, loading: true };
    case SET_LOADING_FALSE:
      return { ...state, loading: false };
    case TOGGLE_DOCUMENT_LIST_POPUP:
      return {
        ...state,
        isDocumentListPopupVisible: action.isVisible,
        auditCaseId: action.auditCaseId,
        documentListPopupTitle: action.popupTitleText,
      };
    case SET_CURRENT_USER_ACTION_MODE:
      return { ...state, currentUserActionMode: action.currentUserActionMode };
    case SET_DOCUMENT_POPUP_MODE:
      return { ...state, documentPopupMode: action.data.documentPopupMode };
    case TOGGLE_WAIT_TIME_MESSAGE_POPUP:
      return {
        ...state,
        isWaitTimeMessagePopupVisible:
          action.data.isWaitTimeMessagePopupVisible,
      };
    case TOGGLE_DOCUMENT_SELECT_ALL_FLAG:
      return {
        ...state,
        isDocumentSelectAllCheckBoxClicked:
          action.isDocumentSelectAllCheckBoxClicked,
      };
    case SET_IS_STOP_DOCUMENT_POLLING:
      return {
        ...state,
        isStopDocumentPooling: action.isStopDocumentPooling,
      };
    case SET_INCLUDE_NON_AUDIT_LEVEL_DOCUMENTS:
      return {
        ...state,
        includeNonAuditLevelDocumentInd:
          action.data.includeNonAuditLevelDocumentInd,
      };
    case REMOVE_SELECTED_FILE:
      return {
        ...state,
        documentDataToSave: state.documentDataToSave.filter(
          (x) => x.selectedFile !== action.data.file
        ),
      };
    case SAVE_DOCUMENT_UPLOAD_GRID_DATA:
      let newData = applyChanges(
        state.documentDataToSaveStore[action.data.uniqueId],
        [action.data.change],
        {
          keyExpr: documentUploadDatagridKeyExpr,
        }
      );
      return {
        ...state,
        documentDataToSaveStore: {
          ...state.documentDataToSaveStore,
          [action.data.uniqueId]: newData
        }
      };
    case SET_SINGLE_DOCUMENT_DATA:
      const firstocumentDataToSave = first<any[]>(state.documentDataToSaveStore[action.data.uniqueId] || []);
      return {
        ...state,
        documentDataToSaveStore: getUpdatedDocumentStore(
          state.documentDataToSaveStore,
          action.data,
          action.data.uniqueId,
          firstocumentDataToSave[documentUploadDatagridKeyExpr],
        ),
      };
    case SET_DOCUMENT_UPLOAD_PROGRESS:
      return {
        ...state,
        documentDataToSaveStore: getUpdatedDocumentStore(
          state.documentDataToSaveStore,
          action.data,
          action.data.uniqueId,
          action.data.documentUploadDatagridKeyExpr,
        ),
      };
    default:
      return state;
  }
};

export const setDocumentManagementGridInstance = (instance) => {
  documentManagementGridInstance = instance;
};

export const refreshDocumentManagementGridInstance = () => {
   if(documentManagementGridInstance)
    {
      documentManagementGridInstance.clearSelection(); 
      documentManagementGridInstance.option("focusedRowKey", null);
      documentManagementGridInstance.refresh();    }
};

const getUpdatedDocumentStore = (
  documentDataToSaveStore: Record<string, any[]>,
  updatedDocumentData: Record<string, any>,
  uniqueStoreIdentifier: string,
  uniqueDocumentIdentifier: string,
) => {
  const documentDataToSave = documentDataToSaveStore[uniqueStoreIdentifier] || [];

  const documentToUpdateIndex = documentDataToSave.findIndex(
    (x) => x[documentUploadDatagridKeyExpr] === uniqueDocumentIdentifier,
  );

  if (documentToUpdateIndex === -1) {
    return { ...documentDataToSaveStore };
  }

  const updatedDocumentDataToSave = [
    ...documentDataToSave.slice(0, documentToUpdateIndex),
    { ...documentDataToSave[documentToUpdateIndex], ...updatedDocumentData },
    ...documentDataToSave.slice(documentToUpdateIndex + 1),
  ];

  return {
    ...documentDataToSaveStore,
    [uniqueStoreIdentifier]: updatedDocumentDataToSave,
  };
};

export default DocumentManagementReducer;
